import { api_base_url, request } from '../utils';

const BASE = (api_base_url || '').replace(/\/+$/, '');

const normalizeHistory = (item) => ({
  id: item?.Id,
  exchangeScore: Number(item?.ExchangeScore || 0),
  exchangeDate: item?.ExchangeDate,
  productId: item?.FK_ExchangeProduct,
  productTitle: item?.ProductTitle || '',
  productDescription: item?.ProductDescription || '',
});

export class ExchangeHistoryService {
  static ENDPOINT = `${BASE}/exchangeHistory`;

  static async complete(exchangeProductId, exchangeScore, interactions = []) {
    return request({
      url: `${this.ENDPOINT}/complete`,
      method: 'POST',
      body: {
        ExchangeProductId: exchangeProductId,
        ExchangeScore: Number(exchangeScore || 0),
        Interactions: interactions.map((interaction) => ({
          Id: interaction.id,
          Quantity: Number(interaction.quantity),
        })),
      },
      responseType: 'text',
    });
  }

  static async getAll() {
    const history = await request({
      url: `${this.ENDPOINT}/`,
      headers: { Accept: 'application/json' }
    });
    if (!Array.isArray(history)) return history;
    return history.map(normalizeHistory);
  }
}

export default ExchangeHistoryService;
